import React, { useMemo } from 'react';
import { Icon } from '@aqarmap/aqarmap-ui';
import Lottie from 'lottie-react';
import startAnimationData from '~/animations/start.json';
import { useTranslation } from 'react-i18next';

type Props = {
  ctas?: React.ReactNode;
  image: React.ReactNode;
  hideOnMobile?: boolean;
};

const ValuationBanner = ({ ctas, image, hideOnMobile = false }: Props) => {
  const { t } = useTranslation('app');
  const services = useMemo(
    () => [
      t('marketAIAnalysis'),
      t('propertyInstantValuation'),
      t('trackDemandLevel'),
    ],
    [t],
  );

  return (
    <section
      className={`bg-orange_light_2 w-full items-center px-3x md:px-[84px] py-4x ${
        hideOnMobile ? 'hidden md:flex' : 'flex'
      }`}
    >
      <div className="w-full flex flex-col-reverse md:flex-row gap-4x md:gap-[92px] justify-center md:justify-start ">
        <div className="w-full flex flex-col justify-center md:justify-start">
          <div className="flex w-full justify-center md:justify-start mb-2x md:mb-3x">
            <div className="flex h-[40px] w-fit gap-x py-x px-2x bg-white rounded-[46px]">
              <Lottie
                animationData={startAnimationData}
                loop={false}
                autoplay={false}
                className="w-[24px] h-[24px]"
              />
              <span className="text-caption_2 md:text-caption text-gray__dark_1">
                {t('poweredByAI')}
              </span>
            </div>
          </div>
          <h1 className="text-title_3 md:text-title_2 text-black mb-3x md:mb-4x">
            {t('knowRealValue')}
          </h1>

          <div className="flex flex-col gap-1.5x mb-3x md:mb-4x">
            {services.map((service, index) => (
              <div
                key={`valuation-service-${index}`}
                className="flex items-start gap-1.5x"
              >
                <span className="flex  flex-shrink-0 p-0.5x rounded-full bg-[#0CB54826] text-green_light">
                  <Icon name="check" size="16px" />
                </span>
                <span className="text-body_2 md:text-body_1 text-gray__dark_2">
                  {service}
                </span>
              </div>
            ))}
          </div>

          {ctas ? (
            <div className="flex flex-col sm:flex-row gap-3x">{ctas}</div>
          ) : null}
        </div>

        {image}
      </div>
    </section>
  );
};

export default ValuationBanner;
